export const gamesBaseURL = `https://lambda.hobbycribbage.com`;
